import React, {useRef, useState} from 'react';
import {UserInfo} from "./controls-user/User-info";
import {ReactComponent as ProfileIcon} from '../../../../../../assets/header/profile.svg';
import useJivoChat from "common/hook/useJivoChat";

export const Controls = () => {
    const [isChatVisible, setIsChatVisible] = useState(false);
    const profileSelectRef = useRef(null);

    const handleChatClick = () => {
        setIsChatVisible(prevState => !prevState);
    };

    useJivoChat(isChatVisible);

    return (
        <div className="controls-col col" ref={profileSelectRef}>
            <div className="app-profile-box">
                <div onClick={handleChatClick} className="profile-prompt">
                    <ProfileIcon />
                </div>
                <UserInfo/>
            </div>
        </div>
    );
};

